import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import { Radio, RadioGroup, RadioGroupProps } from '~c/components/base/radio';

interface Props {
  className?: string;
}

const RadioGroupDemo: React.FC<Props> = ({ className }) => {
  const [value, setValue] = React.useState('label1');

  const handleChange: RadioGroupProps['onChange'] = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <RadioGroup
      className={className}
      title="RadioGroup"
      helperText="helper text"
      name="radio-demo"
      value={value}
      onChange={handleChange}
    >
      <Radio label="Label 1" value="label1" />
      <Radio label="Label 2" value="label2" />
      <Radio label="Label 3" value="label3" />
    </RadioGroup>
  );
};

export default muiStyled(RadioGroupDemo)(({ theme }) => css``);
